import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getBalanceStatus = ({ churchId, fromDate, toDate, period }) => {
  return axios.get(
    `/churches/${churchId}/dashboard/revenue-expense-balance?from_date=${fromDate}&to_date=${toDate}&period=${period}`
  );
};

export const useBalanceStatus = ({
  churchId,
  fromDate,
  toDate,
  period,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["balance-status", churchId, fromDate, toDate, period],
    queryFn: () => getBalanceStatus({ churchId, fromDate, toDate, period }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
